document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("amplifier-slider");
  const priceDisplay = document.getElementById("product-price-display");
  const priceDiffDisplay = document.getElementById("amplifier-price");
  const cartContainer = document.querySelector(".product-cart-container");

  if (!slider) return;

  // ===========================================
  // AMPLIFIER PRODUCT CONFIGURATION
  // Change these values to update the connected amplifier product
  // ===========================================
  // Product handle (the URL slug) - find it in the product URL: /products/[handle]
  const AMPLIFIER_PRODUCT_HANDLE = "amplifier";
  // Variant ID - for adding to cart (even products without variants have a default variant)
  // You can find this by going to the product, checking the URL when editing the variant
  // OR leave empty and the script will use the first variant from the fetched product
  const AMPLIFIER_PRODUCT_VARIANT_ID = ""; // Will be set automatically from fetched product
  // ===========================================

  // Get product data from data attributes (simplified - no more Yes/No variants)
  const basePrice = parseInt(slider.dataset.productPrice);
  const currency = slider.dataset.currency || "GBP";

  // A1: Default is now YES (with amplifier)
  let isActive = true;
  let selectedVariantId = slider.dataset.variantId; // Track main product variant (single variant per product)

  // Store the actual amplifier product price (will be fetched from product)
  let amplifierProductPrice = 0;
  // Store the amplifier variant ID (will be fetched if not manually set)
  let amplifierVariantId = AMPLIFIER_PRODUCT_VARIANT_ID;

  // Helper function to format price (must be defined before first use)
  function formatMoney(cents) {
    // Format as currency without symbol and remove trailing zeros
    const amount = (cents / 100).toFixed(2);
    // Remove .00 or just trailing 0 (e.g., 500.00 -> 500, 500.50 -> 500.5)
    return amount.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
  }

  // Initialize: set default to YES state on page load
  const noText = document.querySelector(".no-yes-slider p:first-of-type");
  const yesText = document.querySelector(".no-yes-slider p:last-of-type");

  // Initial price display will be updated after fetching amplifier product price
  // For now, show +0 until we have the actual price
  priceDiffDisplay.textContent = "+" + formatMoney(0) + " " + currency;
  priceDiffDisplay.style.opacity = "1";

  // Set slider to right (Yes) position visually
  slider.classList.add("slider-right");

  if (noText) {
    noText.style.opacity = "0.5";
  }
  if (yesText) {
    yesText.style.opacity = "1";
    yesText.style.color = "black";
  }

  // Hide cart success initially
  const cartSuccess = document.querySelector(".cart-success");
  const cartForward = document.querySelector(".cart-page-forward");
  const addToOrderButton = document.querySelector(
    ".add-to-order p:nth-child(3)",
  ); // "Add to Order" text
  const productPrice = document.querySelector(".product-price");
  const addingToOrder = document.querySelector(".adding-to-order");
  const notifyButton = document.querySelector(".notify-available");

  // 3-step notification form elements
  const notifyNameContainer = document.querySelector(".notify-name-container");
  const notifyEmailRow = document.querySelector(".notify-email-row");
  const notifyFirstname = document.querySelector(".notify-firstname");
  const notifyLastname = document.querySelector(".notify-lastname");
  const notifyEmail = document.querySelector(".notify-email");
  const notifyArrows = document.querySelectorAll(".notify-arrow");
  const notifySubmit = document.querySelector(".notify-submit");
  let currentNotifyStep = 1;

  if (cartSuccess) cartSuccess.style.display = "none";

  // Check if MAIN product is out of stock (from data attribute set by Liquid)
  // Using let so it can be updated when switching products via dial selector
  let isMainProductOutOfStock =
    document.querySelector(".add-to-order")?.dataset.outOfStock === "true";
  let isEmailInputMode = false;

  // Track amplifier availability (will be updated after fetching inventory)
  let isAmplifierAvailable = true;

  // Fetch amplifier product inventory and price to determine availability
  async function checkAmplifierInventory() {
    try {
      const response = await fetch(`/products/${AMPLIFIER_PRODUCT_HANDLE}.js`);
      if (response.ok) {
        const productData = await response.json();
        // Check if any variant is available
        isAmplifierAvailable = productData.available;
        // Get the amplifier product price (first variant price)
        if (productData.variants && productData.variants.length > 0) {
          amplifierProductPrice = productData.variants[0].price;
          // Auto-set variant ID if not manually configured
          if (!amplifierVariantId) {
            amplifierVariantId = productData.variants[0].id.toString();
          }
        } else {
          amplifierProductPrice = productData.price || 0;
        }

        // Store amplifier price on slider for access when switching products via dial selector
        slider.dataset.amplifierProductPrice = amplifierProductPrice.toString();

        // Update UI based on amplifier availability and price
        updateToggleState();
      } else {
        console.error(
          "Failed to fetch amplifier product. Check that AMPLIFIER_PRODUCT_HANDLE is correct:",
          AMPLIFIER_PRODUCT_HANDLE,
        );
        isAmplifierAvailable = false;
        amplifierProductPrice = 0;
        updateToggleState();
      }
    } catch (error) {
      console.error("Error fetching amplifier inventory:", error);
      // Default to unavailable if fetch fails
      isAmplifierAvailable = false;
      amplifierProductPrice = 0;
      updateToggleState();
    }
  }

  // Function to update toggle state based on availability
  function updateToggleState() {
    const variantSelector = document.querySelector(".product-variant-selector");

    // If main product is out of stock, show notify button and hide With Amplifier
    if (isMainProductOutOfStock) {
      // Hide "With Amplifier" section
      if (variantSelector) {
        variantSelector.style.display = "none";
      }
      if (notifyButton) {
        notifyButton.style.display = "block";
      }
      const cartOrderButton = document.querySelector(".cart-order");
      if (cartOrderButton) {
        cartOrderButton.style.display = "none";
      }
      // Hide price when out of stock
      if (productPrice) {
        productPrice.style.display = "none";
      }
      return;
    }

    // Main product is in stock - show add to order and With Amplifier
    if (variantSelector) {
      variantSelector.style.display = "";
    }
    if (notifyButton) {
      notifyButton.style.display = "none";
    }
    const cartOrderButton = document.querySelector(".cart-order");
    if (cartOrderButton) {
      cartOrderButton.style.display = "block";
    }
    if (productPrice) {
      productPrice.style.display = "flex";
    }

    // A2: Default to YES if amplifier is available
    if (isAmplifierAvailable) {
      isActive = true;
      slider.classList.add("slider-right");
      if (noText) {
        noText.style.opacity = "0.5";
      }
      if (yesText) {
        yesText.style.opacity = "1";
        yesText.style.color = "black";
      }
      // Show amplifier product price (actual price, not diff)
      priceDiffDisplay.textContent =
        "+" + formatMoney(amplifierProductPrice) + " " + currency;
      priceDiffDisplay.style.opacity = "1";
      // Update Add to Order total: main product + amplifier
      const currentBasePrice = parseInt(slider.dataset.productPrice);
      const totalPrice = currentBasePrice + amplifierProductPrice;
      priceDisplay.textContent = formatMoney(totalPrice) + " " + currency;
    } else {
      // Amplifier not available - default to NO
      isActive = false;
      slider.classList.remove("slider-right");
      if (noText) {
        noText.style.opacity = "1";
      }
      if (yesText) {
        yesText.style.opacity = "0.5";
        yesText.style.color = "";
      }
      priceDiffDisplay.textContent = "+" + formatMoney(0) + " " + currency;
      priceDiffDisplay.style.opacity = "0.5";
      // Show only main product price when No
      const currentBasePrice = parseInt(slider.dataset.productPrice);
      priceDisplay.textContent = formatMoney(currentBasePrice) + " " + currency;
    }
  }

  // Initial out-of-stock state check (before async inventory check)
  const initialVariantSelector = document.querySelector(
    ".product-variant-selector",
  );

  if (isMainProductOutOfStock) {
    // Hide "With Amplifier" section when out of stock
    if (initialVariantSelector) {
      initialVariantSelector.style.display = "none";
    }
    // Show notify button
    if (notifyButton) {
      notifyButton.style.display = "block";
    }
    // Hide cart order button
    const cartOrderButton = document.querySelector(".cart-order");
    if (cartOrderButton) {
      cartOrderButton.style.display = "none";
    }
    // Hide price
    if (productPrice) {
      productPrice.style.display = "none";
    }
  } else {
    // Show "With Amplifier" section when in stock
    if (initialVariantSelector) {
      initialVariantSelector.style.display = "";
    }
    // Hide notify button
    if (notifyButton) {
      notifyButton.style.display = "none";
    }
    // Show cart order button
    const cartOrderButton = document.querySelector(".cart-order");
    if (cartOrderButton) {
      cartOrderButton.style.display = "block";
    }
  }

  // Check amplifier inventory on page load
  checkAmplifierInventory();

  // Sticky positioning for cart container - ONLY on desktop (above 730px)
  if (cartContainer) {
    let isSticky = false;
    const parentElement = cartContainer.parentElement;

    function updateCartSticky() {
      // Check if we're on mobile (730px or below)
      const isMobile = window.innerWidth <= 730;

      if (isMobile) {
        // On mobile: remove any sticky positioning, let it flow naturally
        cartContainer.style.position = "relative";
        cartContainer.style.top = "";
        cartContainer.style.right = "";
        cartContainer.style.width = "100%";
        isSticky = false;
        return;
      }

      // Desktop: apply sticky behavior
      const parentRect = parentElement.getBoundingClientRect();
      const parentViewportTop = parentRect.top;

      // If parent's top is at or above 12px from viewport top, stick it
      if (parentViewportTop <= 12) {
        cartContainer.style.position = "fixed";
        cartContainer.style.top = "12px";
        cartContainer.style.right = "12px";
        cartContainer.style.width = "260px";
        isSticky = true;
      } else {
        // Return to absolute when scrolling back up or when switching to desktop
        cartContainer.style.position = "absolute";
        cartContainer.style.top = "0";
        cartContainer.style.right = "12px";
        cartContainer.style.width = "260px";
        isSticky = false;
      }
    }

    // Debounce wrapper for better resize performance
    function debounce(fn, wait) {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, arguments), wait);
      };
    }

    window.addEventListener("scroll", updateCartSticky);
    window.addEventListener("resize", debounce(updateCartSticky, 100));
    updateCartSticky(); // Call on load
  }

  // Make entire product-variant-selector clickable for amplifier toggle
  const variantSelectorDiv = document.querySelector(
    ".product-variant-selector",
  );
  if (variantSelectorDiv && slider) {
    variantSelectorDiv.style.cursor = "pointer";
    variantSelectorDiv.addEventListener("click", function (e) {
      // Reset to "Add to Order" if user interacts
      resetToAddToCart();
      // Trigger slider click
      slider.click();
    });
  }

  slider.addEventListener("click", function (e) {
    // Reset to "Add to Order" if user interacts
    resetToAddToCart();
    // Stop propagation to prevent double-triggering from parent div click
    e.stopPropagation();

    // Prevent toggle if main product is out of stock
    if (isMainProductOutOfStock) {
      return;
    }

    // If trying to toggle to YES but amplifier isn't available, don't allow
    if (!isActive && !isAmplifierAvailable) {
      return;
    }

    isActive = !isActive;
    const noText = document.querySelector(".no-yes-slider p:first-of-type");
    const yesText = document.querySelector(".no-yes-slider p:last-of-type");

    if (isActive) {
      // Switched to "Yes" (With Amplifier) - currently showing amplifier price
      this.classList.add("slider-right");

      // Immediately fade out "No" text and fade in "Yes" text with animation
      if (noText) {
        noText.style.transition = "opacity 0.275s ease";
        noText.style.opacity = "0.5";
      }
      if (yesText) {
        yesText.style.transition = "opacity 0.275s ease";
        yesText.style.opacity = "1";
      }

      // Fade in price diff and change "Yes" text color - sync with animation
      priceDiffDisplay.style.transition = "opacity 0.275s ease";
      priceDiffDisplay.style.opacity = "1";

      // Fade out and back in the main price during the 275ms animation
      priceDisplay.style.transition = "opacity 0.275s ease";
      priceDisplay.style.opacity = "0";

      setTimeout(() => {
        // Show amplifier product price (actual price)
        priceDiffDisplay.textContent =
          "+" + formatMoney(amplifierProductPrice) + " " + currency;

        // Update main price to combined total (main + amplifier) and fade back in
        const currentBasePrice = parseInt(slider.dataset.productPrice);
        const totalPrice = currentBasePrice + amplifierProductPrice;
        priceDisplay.textContent = formatMoney(totalPrice) + " " + currency;
        priceDisplay.style.opacity = "1";

        // A3: SKU no longer switches with amplifier toggle - removed SKU update

        // Turn "Yes" text black at the end of animation
        if (yesText) {
          yesText.style.color = "black";
        }
      }, 137.5); // Half of 275ms - update at midpoint of fade
    } else {
      // Switched to "No" (Default) - currently showing base price
      this.classList.remove("slider-right");

      // Fade out "Yes" text and fade in "No" text with animation
      if (noText) {
        noText.style.transition = "opacity 0.275s ease";
        noText.style.opacity = "1";
      }
      if (yesText) {
        yesText.style.transition = "opacity 0.275s ease";
        yesText.style.opacity = "0.5";
        yesText.style.color = ""; // Reset color
      }

      // Fade out price diff with animation
      priceDiffDisplay.style.transition = "opacity 0.275s ease";
      priceDiffDisplay.style.opacity = "0.5";

      // Fade out and back in the main price during the 275ms animation
      priceDisplay.style.transition = "opacity 0.275s ease";
      priceDisplay.style.opacity = "0";

      setTimeout(() => {
        // Show +0 when amplifier is not selected
        priceDiffDisplay.textContent = "+" + formatMoney(0) + " " + currency;

        // Update main price to base price only (no amplifier) and fade back in
        const currentBasePrice = parseInt(slider.dataset.productPrice);
        priceDisplay.textContent =
          formatMoney(currentBasePrice) + " " + currency;
        priceDisplay.style.opacity = "1";

        // A3: SKU no longer switches with amplifier toggle - removed SKU update
      }, 137.5); // Half of 275ms - update at midpoint of fade
    }
  });

  // Add to cart functionality
  const addToOrderDiv = document.querySelector(".add-to-order");
  const productSelector = document.querySelector(".product-selector");

  if (addToOrderDiv) {
    addToOrderDiv.addEventListener("click", async function (e) {
      // If main product is out of stock, handle email notification flow
      if (isMainProductOutOfStock) {
        // If already in email input mode, don't do anything on general click
        if (isEmailInputMode) return;

        // Switch to email input mode
        isEmailInputMode = true;
        showNotifyForm();
        return;
      }

      // Immediately show loading state
      showLoadingState();

      // Use the product's variant ID (products now have single variant, not Yes/No)
      // The amplifier toggle adds a separate product, not a different variant
      const mainVariantId = slider.dataset.variantId;

      if (!mainVariantId) {
        console.error("No variant ID found");
        hideLoadingState();
        return;
      }

      try {
        // A2A: Build items array - always add main product, add amplifier product if toggle is Yes
        const itemsToAdd = [
          {
            id: mainVariantId,
            quantity: 1,
          },
        ];

        // If "With Amplifier" is Yes, also add the connected amplifier product
        if (isActive && amplifierVariantId) {
          itemsToAdd.push({
            id: amplifierVariantId,
            quantity: 1,
          });
        }

        // Add to cart via Shopify AJAX API
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: itemsToAdd,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to add to cart");
        }

        const result = await response.json();
        console.log("Added to cart:", result);

        // Trigger custom event to notify other scripts about cart update
        const cartUpdateEvent = new CustomEvent("cartUpdated", {
          detail: result,
        });
        document.dispatchEvent(cartUpdateEvent);

        // Animate the success state
        animateCartSuccess();
      } catch (error) {
        console.error("Error adding to cart:", error);
        alert("Failed to add item to cart. Please try again.");
        hideLoadingState();
      }
    });
  }

  function showLoadingState() {
    // Change background to white and center justify
    addToOrderDiv.style.backgroundColor = "white";
    addToOrderDiv.style.justifyContent = "center";

    // Immediately hide default items
    if (addToOrderButton) addToOrderButton.style.display = "none";
    if (productPrice) productPrice.style.display = "none";

    // Show and start pulsating "Adding to Order"
    if (addingToOrder) {
      addingToOrder.style.display = "block";
      addingToOrder.style.animation = "pulsate 1s ease-in-out infinite";
    }

    // Create and animate loading bar
    const loadingBar = document.createElement("div");
    loadingBar.className = "loading-bar";
    loadingBar.style.position = "absolute";
    loadingBar.style.left = "0";
    loadingBar.style.top = "0";
    loadingBar.style.width = "100%";
    loadingBar.style.height = "100%";
    loadingBar.style.backgroundColor = "#ef9b00";
    loadingBar.style.transform = "translateX(-100%)";
    loadingBar.style.transition = "transform 1s ease-out";
    loadingBar.style.zIndex = "1";

    addToOrderDiv.appendChild(loadingBar);

    // Start loading bar animation
    setTimeout(() => {
      loadingBar.style.transform = "translateX(0)";
    }, 10);

    // Make text appear above loading bar
    if (addingToOrder) {
      addingToOrder.style.position = "relative";
      addingToOrder.style.zIndex = "2";
    }
  }

  function hideLoadingState() {
    // Reset to default styling
    addToOrderDiv.style.backgroundColor = "#ef9b00";
    addToOrderDiv.style.justifyContent = "space-between";

    // Show default items
    if (addToOrderButton) addToOrderButton.style.display = "block";
    if (productPrice) productPrice.style.display = "flex";

    // Hide adding to order text
    if (addingToOrder) {
      addingToOrder.style.display = "none";
      addingToOrder.style.animation = "";
    }

    // Remove loading bar
    const loadingBar = addToOrderDiv.querySelector(".loading-bar");
    if (loadingBar) {
      loadingBar.remove();
    }
  }

  // 3-step notification form functions
  function showNotifyForm() {
    // Fade out notify button
    if (notifyButton) {
      notifyButton.style.transition = "opacity 0.3s ease";
      notifyButton.style.opacity = "0";
    }

    // Fade out product-selector
    if (productSelector) {
      productSelector.style.transition = "opacity 0.3s ease";
      productSelector.style.opacity = "0";
    }

    setTimeout(() => {
      // Hide notify button
      if (notifyButton) notifyButton.style.display = "none";

      // Hide product-selector
      if (productSelector) productSelector.style.display = "none";

      // Change add-to-order background to white with border
      addToOrderDiv.style.backgroundColor = "white";
      addToOrderDiv.style.borderTop = "none";

      // Show notify name container (First Name, Last Name)
      if (notifyNameContainer) {
        notifyNameContainer.style.display = "flex";
        notifyNameContainer.style.opacity = "0";
        notifyNameContainer.style.transition = "opacity 0.3s ease";

        setTimeout(() => {
          notifyNameContainer.style.opacity = "1";
        }, 10);
      }

      // Show email row inside add-to-order
      if (notifyEmailRow) {
        notifyEmailRow.style.display = "flex";
        notifyEmailRow.style.opacity = "0";
        notifyEmailRow.style.transition = "opacity 0.3s ease";

        setTimeout(() => {
          notifyEmailRow.style.opacity = "1";
        }, 10);
      }

      // Reset to step 1
      currentNotifyStep = 1;
      updateNotifyArrows();

      // Focus first input
      if (notifyFirstname) notifyFirstname.focus();
    }, 300);
  }

  function updateNotifyArrows() {
    // Email submit arrow is always visible (opacity controlled by email validation)
    // Name fields no longer have arrows
  }

  function moveToNextStep() {
    const currentInput = getCurrentStepInput();

    // Validate current input
    if (!currentInput || !currentInput.value.trim()) {
      currentInput?.focus();
      return false;
    }

    // Add has-value class to show black text
    currentInput.classList.add("has-value");

    if (currentNotifyStep < 3) {
      currentNotifyStep++;
      updateNotifyArrows();

      // Focus next input
      const nextInput = getCurrentStepInput();
      if (nextInput) nextInput.focus();
      return true;
    }

    return false;
  }

  function getCurrentStepInput() {
    switch (currentNotifyStep) {
      case 1:
        return notifyFirstname;
      case 2:
        return notifyLastname;
      case 3:
        return notifyEmail;
      default:
        return null;
    }
  }

  function submitNotifyForm() {
    // Validate email
    if (!notifyEmail || !notifyEmail.value.trim()) {
      notifyEmail?.focus();
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(notifyEmail.value.trim())) {
      notifyEmail?.focus();
      return;
    }

    // Get all values
    const firstName = notifyFirstname ? notifyFirstname.value.trim() : "";
    const lastName = notifyLastname ? notifyLastname.value.trim() : "";
    const email = notifyEmail ? notifyEmail.value.trim() : "";

    // Get product data from form data attributes
    const notifyForm = document.querySelector(".notify-name-container");

    // Check if user has selected a different product via dial selector
    const activeSelector =
      document.querySelector(".dial-variant-text.active") ||
      document.querySelector(".circle-selector-left");

    // Get product info - prefer selected dial variant, fall back to form data attributes
    const productId =
      activeSelector?.dataset.variantId || notifyForm?.dataset.productId || "";
    const productTitle =
      activeSelector?.dataset.productTitle ||
      notifyForm?.dataset.productTitle ||
      "";
    const productUrl = notifyForm?.dataset.productUrl || window.location.href;
    const productImage =
      activeSelector?.dataset.productImage ||
      notifyForm?.dataset.productImage ||
      "";
    const variantId =
      activeSelector?.dataset.variantId || notifyForm?.dataset.variantId || "";
    const variantSku =
      activeSelector?.dataset.productSku ||
      notifyForm?.dataset.variantSku ||
      "";
    const productHandle = activeSelector?.dataset.productHandle || "";

    console.log("Notification submitted:", {
      firstName,
      lastName,
      email,
      productId,
      productTitle,
      productUrl,
      productImage,
      variantId,
      variantSku,
      productHandle,
    });

    // =====================================================
    // KLAVIYO INTEGRATION - Event-Based Tracking for Product Interest
    // =====================================================
    // Step 1: Track "Product Enquiry" event (preserves all product interests)
    // Step 2: Subscribe to list WITHOUT marketing consent (product-only signup)
    // =====================================================

    const klaviyoCompanyId = "XU7nPX";
    const klaviyoListId = "S83sAt";

    // Step 1: Track "Product Enquiry" event
    fetch(
      "https://a.klaviyo.com/client/events/?company_id=" + klaviyoCompanyId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-02-15",
        },
        body: JSON.stringify({
          data: {
            type: "event",
            attributes: {
              properties: {
                product_id: productId,
                product_title: productTitle,
                product_handle: productHandle,
                variant_id: variantId,
                variant_sku: variantSku,
                product_url: productUrl,
                product_image: productImage,
              },
              time: new Date().toISOString(),
              metric: {
                data: {
                  type: "metric",
                  attributes: {
                    name: "Product Enquiry",
                  },
                },
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    first_name: firstName,
                    last_name: lastName,
                  },
                },
              },
            },
          },
        }),
      },
    )
      .then((response) => {
        console.log("Klaviyo event tracking status:", response.status);
        if (response.ok) {
          console.log("Product Enquiry event tracked successfully");
        } else {
          return response.text().then((text) => {
            console.error("Klaviyo event tracking error:", text);
          });
        }
      })
      .catch((error) => {
        console.error("Klaviyo event tracking error:", error);
      });

    // Step 2: Subscribe to list WITHOUT marketing consent (product-only signup)
    fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" +
        klaviyoCompanyId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-02-15",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    first_name: firstName,
                    last_name: lastName,
                    properties: {
                      last_product_interest_id: productId,
                      last_product_interest_title: productTitle,
                      last_product_interest_date: new Date().toISOString(),
                      // DO NOT set has_marketing_consent here - this is a product-only signup
                    },
                  },
                },
              },
              custom_source: "Product Notify Form",
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: klaviyoListId,
                },
              },
            },
          },
        }),
      },
    )
      .then((response) => {
        console.log("Klaviyo response status:", response.status);
        if (response.ok) {
          console.log(
            "Klaviyo list subscription successful - Status:",
            response.status,
          );
          console.log(
            "Note: If double opt-in is enabled, subscriber must confirm via email before appearing in list.",
          );
        } else {
          return response.text().then((text) => {
            console.error(
              "Klaviyo subscription error - Status:",
              response.status,
            );
            console.error("Response:", text);
          });
        }
      })
      .catch((error) => {
        console.error("Klaviyo subscription error:", error);
      });

    // Show loading bar animation on add-to-order
    addToOrderDiv.style.position = "relative";
    addToOrderDiv.style.overflow = "hidden";

    // Create and animate loading bar
    const loadingBar = document.createElement("div");
    loadingBar.className = "loading-bar";
    loadingBar.style.position = "absolute";
    loadingBar.style.left = "0";
    loadingBar.style.top = "0";
    loadingBar.style.width = "100%";
    loadingBar.style.height = "100%";
    loadingBar.style.backgroundColor = "#ef9b00";
    loadingBar.style.transform = "translateX(-100%)";
    loadingBar.style.transition = "transform 0.5s ease-out";
    loadingBar.style.zIndex = "1";

    addToOrderDiv.appendChild(loadingBar);

    // Start loading bar animation
    setTimeout(() => {
      loadingBar.style.transform = "translateX(0)";
    }, 10);

    // After loading bar completes (0.5s), show thank you overlay
    setTimeout(() => {
      // Remove the loading bar
      if (loadingBar && loadingBar.parentNode) {
        loadingBar.remove();
      }

      // Hide all current content in product-cart-container
      if (notifyEmailRow) {
        notifyEmailRow.style.display = "none";
      }
      if (notifyNameContainer) {
        notifyNameContainer.style.display = "none";
      }
      if (productSelector) {
        productSelector.style.display = "none";
      }
      const variantSelector = document.querySelector(
        ".product-variant-selector",
      );
      if (variantSelector) {
        variantSelector.style.display = "none";
      }
      if (notifyButton) {
        notifyButton.style.display = "none";
      }
      addToOrderDiv.style.display = "none";

      // Set cart container height to 140px for the thank you overlay
      cartContainer.style.height = "140px";

      // Create and show thank you overlay
      const thankYouOverlay = document.createElement("div");
      thankYouOverlay.className = "notify-thank-you-overlay type-micro";
      thankYouOverlay.textContent =
        "Thank you. You will receive an email shortly with information on how to complete your purchase.";

      // Slow, gentle fade in animation (1s for soft appearance)
      thankYouOverlay.style.display = "flex";
      thankYouOverlay.style.opacity = "0";
      thankYouOverlay.style.transition = "opacity 1s ease";
      cartContainer.appendChild(thankYouOverlay);

      // Wait 200ms after bar completes, then fade in the overlay
      setTimeout(() => {
        thankYouOverlay.style.opacity = "1";
        thankYouOverlay.classList.add("visible");

        // After fade-in completes (1s) + 1s display time, fade out
        setTimeout(() => {
          // Fade out the overlay (1s ease to match fade in)
          thankYouOverlay.style.transition = "opacity 1s ease";
          thankYouOverlay.style.opacity = "0";
          thankYouOverlay.classList.remove("visible");

          // After fade out completes (1s), remove overlay and reset
          setTimeout(() => {
            thankYouOverlay.remove();
            // Reset cart container height
            cartContainer.style.height = "";
            resetToDefaultState();
          }, 1000);
        }, 1000 + 1000); // 1s fade-in + 1s display time
      }, 200); // 200ms pause after bar completes before fade starts
    }, 500);
  }

  // Function to reset everything to default state (before notify button was clicked)
  function resetToDefaultState() {
    // Reset form inputs
    if (notifyFirstname) {
      notifyFirstname.value = "";
      notifyFirstname.classList.remove("has-value");
    }
    if (notifyLastname) {
      notifyLastname.value = "";
      notifyLastname.classList.remove("has-value");
    }
    if (notifyEmail) {
      notifyEmail.value = "";
      notifyEmail.classList.remove("has-value");
    }

    // Reset step counter
    currentNotifyStep = 1;

    // Reset step rows visibility
    const step1Row = document.querySelector('.notify-input-row[data-step="1"]');
    const step2Row = document.querySelector('.notify-input-row[data-step="2"]');
    if (step1Row) {
      step1Row.style.display = "flex";
      step1Row.style.opacity = "1";
    }
    if (step2Row) {
      step2Row.style.display = "flex";
      step2Row.style.opacity = "1";
    }

    // Reset arrows visibility
    const firstArrow = step1Row?.querySelector(".notify-arrow");
    const secondArrow = step2Row?.querySelector(".notify-arrow");
    if (firstArrow) firstArrow.style.display = "block";
    if (secondArrow) secondArrow.style.display = "none";

    // Show variant selector if needed (for in-stock products)
    const variantSelector = document.querySelector(".product-variant-selector");
    if (variantSelector && !isMainProductOutOfStock) {
      variantSelector.style.display = "block";
      variantSelector.style.opacity = "1";
    }

    // Show product-selector
    if (productSelector) {
      productSelector.style.display = "block";
      productSelector.style.opacity = "1";
    }

    // Reset add-to-order div
    addToOrderDiv.style.display = "flex";
    addToOrderDiv.style.backgroundColor = "#ef9b00";

    // Show notify button (for out of stock) or add to order button (for in stock)
    if (isMainProductOutOfStock) {
      if (notifyButton) {
        notifyButton.style.display = "block";
        notifyButton.style.opacity = "1";
      }
      const cartOrderButton = document.querySelector(".cart-order");
      if (cartOrderButton) {
        cartOrderButton.style.display = "none";
      }
    } else {
      const cartOrderButton = document.querySelector(".cart-order");
      if (cartOrderButton) {
        cartOrderButton.style.display = "block";
        cartOrderButton.style.opacity = "1";
      }
      if (notifyButton) {
        notifyButton.style.display = "none";
      }
    }

    // Hide notify containers
    if (notifyNameContainer) {
      notifyNameContainer.style.display = "none";
      notifyNameContainer.style.opacity = "1";
    }
    if (notifyEmailRow) {
      notifyEmailRow.style.display = "none";
      notifyEmailRow.style.opacity = "1";
    }

    // Reset email submit arrow opacity
    if (notifySubmit) {
      notifySubmit.style.opacity = "0.3";
    }

    // Show product price
    const productPriceEl = document.querySelector(".product-price");
    if (productPriceEl && !isMainProductOutOfStock) {
      productPriceEl.style.display = "flex";
    }

    // Reset email input mode flag
    isEmailInputMode = false;
  }

  // Set up event listeners for the 3-step form
  if (notifyNameContainer) {
    // Prevent clicks from bubbling to add-to-order
    notifyNameContainer.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  // Handle notify close button click
  const notifyClose = document.getElementById("notify-close");
  if (notifyClose) {
    notifyClose.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeNotifyForm();
    });
  }

  // Function to close notify form and return to default state
  function closeNotifyForm() {
    // Fade out the notify name container
    if (notifyNameContainer) {
      notifyNameContainer.style.transition = "opacity 0.3s ease";
      notifyNameContainer.style.opacity = "0";
    }

    // Fade out the entire add-to-order div (which contains email row) together
    if (addToOrderDiv) {
      addToOrderDiv.style.transition = "opacity 0.3s ease";
      addToOrderDiv.style.opacity = "0";
    }

    setTimeout(() => {
      // Hide notify name container
      if (notifyNameContainer) {
        notifyNameContainer.style.display = "none";
      }

      // Hide email row
      if (notifyEmailRow) {
        notifyEmailRow.style.display = "none";
      }

      // Reset form inputs
      if (notifyFirstname) {
        notifyFirstname.value = "";
        notifyFirstname.classList.remove("has-value");
      }
      if (notifyLastname) {
        notifyLastname.value = "";
        notifyLastname.classList.remove("has-value");
      }
      if (notifyEmail) {
        notifyEmail.value = "";
        notifyEmail.classList.remove("has-value");
      }

      // Reset email submit arrow opacity
      if (notifySubmit) {
        notifySubmit.style.opacity = "0.3";
      }

      // Reset step counter
      currentNotifyStep = 1;

      // Reset add-to-order styles and restore opacity
      addToOrderDiv.style.backgroundColor = "#ef9b00";
      addToOrderDiv.style.border = "";
      addToOrderDiv.style.borderTop = "";
      addToOrderDiv.style.opacity = "1";
      addToOrderDiv.style.transition = "";

      // Show product-selector
      if (productSelector) {
        productSelector.style.display = "block";
        productSelector.style.opacity = "0";
        productSelector.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          productSelector.style.opacity = "1";
        }, 10);
      }

      // Show notify button again
      if (notifyButton) {
        notifyButton.style.display = "block";
        notifyButton.style.opacity = "0";
        notifyButton.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          notifyButton.style.opacity = "1";
        }, 10);
      }

      // Reset email input mode flag
      isEmailInputMode = false;
    }, 300);
  }

  if (notifyEmailRow) {
    // Prevent clicks from bubbling to add-to-order
    notifyEmailRow.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  // Handle Enter key on inputs
  [notifyFirstname, notifyLastname, notifyEmail].forEach((input, index) => {
    if (input) {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          if (index < 2) {
            // Move to next step for First Name and Last Name
            moveToNextStep();
          } else {
            // Submit on Enter for Email
            submitNotifyForm();
          }
        }
      });

      // Update has-value class on input
      input.addEventListener("input", function () {
        if (this.value.trim()) {
          this.classList.add("has-value");
        } else {
          this.classList.remove("has-value");
        }

        // For email input, update submit arrow opacity based on valid email
        if (this === notifyEmail && notifySubmit) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (emailRegex.test(this.value.trim())) {
            notifySubmit.style.opacity = "1";
          } else {
            notifySubmit.style.opacity = "0.3";
          }
        }
      });
    }
  });

  // Handle submit button click directly
  if (notifySubmit) {
    notifySubmit.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      submitNotifyForm();
    });
  }

  let successTimeoutId = null; // Track success auto-reset timeout

  function resetFromSuccess() {
    // Clear any pending auto-reset
    if (successTimeoutId) {
      clearTimeout(successTimeoutId);
      successTimeoutId = null;
    }

    // Fade out success message only
    if (cartSuccess) {
      cartSuccess.style.transition = "opacity 0.3s ease";
      cartSuccess.style.opacity = "0";
    }

    // After success message fades out, restore dial/variant selector but KEEP the "Go to Order" button
    setTimeout(() => {
      // Hide cart success message
      if (cartSuccess) {
        cartSuccess.style.display = "none";
        cartSuccess.style.transition = "";
      }

      // Reset product-selector height back to original
      productSelector.style.height = "100px";

      // Get all elements to restore
      const selectorChildren = productSelector.querySelectorAll(
        ":scope > *:not(.cart-success)",
      );
      const variantSelector = document.querySelector(
        ".product-variant-selector",
      );

      // Check if current product is out of stock
      const currentlyOutOfStock =
        document.querySelector(".add-to-order")?.dataset.outOfStock === "true";

      // Show and fade in variant selector ONLY if product is in stock
      if (variantSelector && !currentlyOutOfStock) {
        variantSelector.style.display = "";
        variantSelector.style.opacity = "0";
        variantSelector.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          variantSelector.style.opacity = "1";
        }, 10);
      }

      // Show and fade in selector children (housing material, dial wrapper)
      selectorChildren.forEach((child) => {
        child.style.display = "";
        child.style.opacity = "0";
        child.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          child.style.opacity = "1";
        }, 10);
      });

      // Keep "Go to Order" button visible, don't restore "Add to Order" yet
    }, 300);
  }

  function resetToAddToCart() {
    // This function resets everything back to the original "Add to Order" state
    // Clear any pending auto-reset
    if (successTimeoutId) {
      clearTimeout(successTimeoutId);
      successTimeoutId = null;
    }

    // Fade out success message and forward button
    if (cartSuccess) {
      cartSuccess.style.transition = "opacity 0.3s ease";
      cartSuccess.style.opacity = "0";
    }

    if (cartForward) {
      cartForward.style.transition = "opacity 0.3s ease";
      cartForward.style.opacity = "0";
    }

    // After fade completes, reset everything back to original state
    setTimeout(() => {
      // Hide cart success
      if (cartSuccess) {
        cartSuccess.style.display = "none";
        cartSuccess.style.transition = "";
      }

      // Hide cart forward button
      if (cartForward) {
        cartForward.style.display = "none";
        cartForward.style.transition = "";
      }

      // Reset product-selector height back to original
      productSelector.style.height = "100px";

      // Get all elements to restore
      const selectorChildren = productSelector.querySelectorAll(
        ":scope > *:not(.cart-success)",
      );
      const variantSelector = document.querySelector(
        ".product-variant-selector",
      );

      // Check if current product is out of stock
      const currentlyOutOfStock =
        document.querySelector(".add-to-order")?.dataset.outOfStock === "true";

      // Show and fade in variant selector ONLY if product is in stock
      if (variantSelector && !currentlyOutOfStock) {
        variantSelector.style.display = "";
        variantSelector.style.opacity = "0";
        variantSelector.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          variantSelector.style.opacity = "1";
        }, 10);
      }

      // Show and fade in selector children (housing material, dial wrapper)
      selectorChildren.forEach((child) => {
        child.style.display = "";
        child.style.opacity = "0";
        child.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          child.style.opacity = "1";
        }, 10);
      });

      // Restore the add-to-order button (cart-order text) ONLY if in stock
      const cartOrderButton = document.querySelector(".cart-order");
      const notifyButton = document.querySelector(".notify-available");

      if (currentlyOutOfStock) {
        // Out of stock - show notify, hide add to order and price
        if (cartOrderButton) {
          cartOrderButton.style.display = "none";
        }
        if (notifyButton) {
          notifyButton.style.display = "block";
        }
        if (productPrice) {
          productPrice.style.display = "none";
        }
      } else {
        // In stock - show add to order and price, hide notify
        if (cartOrderButton) {
          cartOrderButton.style.display = "block";
        }
        if (notifyButton) {
          notifyButton.style.display = "none";
        }
        if (productPrice) {
          productPrice.style.display = "flex";
        }
      }

      // Completely reset add-to-order div to default state
      if (addToOrderDiv) {
        addToOrderDiv.style.backgroundColor = "#ef9b00";
        addToOrderDiv.style.justifyContent = "space-between";

        // Remove any loading bars that might exist
        const loadingBar = addToOrderDiv.querySelector(".loading-bar");
        if (loadingBar) {
          loadingBar.remove();
        }
      }

      // Show "Add to Order" text only if in stock
      if (addToOrderButton && !currentlyOutOfStock) {
        addToOrderButton.style.display = "block";
      } else if (addToOrderButton) {
        addToOrderButton.style.display = "none";
      }

      // Hide "Adding to Order" text and stop animation
      if (addingToOrder) {
        addingToOrder.style.display = "none";
        addingToOrder.style.animation = "";
      }
    }, 300);
  }

  function animateCartSuccess() {
    // Hide everything in .product-selector with fade out
    const selectorChildren = productSelector.querySelectorAll(
      ":scope > *:not(.cart-success)",
    );
    selectorChildren.forEach((child) => {
      child.style.transition = "opacity 0.3s ease";
      child.style.opacity = "0";
    });

    // Also fade out product variant selector at the same time
    const variantSelector = document.querySelector(".product-variant-selector");
    if (variantSelector) {
      variantSelector.style.transition = "opacity 0.3s ease";
      variantSelector.style.opacity = "0";
    }

    // After fade out, show cart success and forward button
    setTimeout(() => {
      // Hide the faded elements instantly (no transition)
      selectorChildren.forEach((child) => {
        child.style.display = "none";
      });

      // Hide adding to order text
      if (addingToOrder) {
        addingToOrder.style.display = "none";
        addingToOrder.style.animation = "";
      }

      // Hide the .cart-order button
      const cartOrderButton = document.querySelector(".cart-order");
      if (cartOrderButton) {
        cartOrderButton.style.display = "none";
      }

      // Hide product variant selector completely after fade
      if (variantSelector) {
        variantSelector.style.display = "none";
      }

      // Add 35px height to product-selector
      productSelector.style.height = "135px";

      // Show cart success and cart forward button with fade in
      if (cartSuccess) {
        cartSuccess.style.display = "flex";
        cartSuccess.style.opacity = "0";
        cartSuccess.style.transition = "opacity 0.3s ease";
        // Trigger fade in after display change
        setTimeout(() => {
          cartSuccess.style.opacity = "1";
        }, 10);
      }

      // Show cart forward button
      if (cartForward) {
        cartForward.style.display = "flex";
        cartForward.style.opacity = "0";
        cartForward.style.backgroundColor = "#ef9b00";
        cartForward.style.width = "100%";
        cartForward.style.textAlign = "center";
        cartForward.style.cursor = "pointer";
        cartForward.style.textDecoration = "none";
        cartForward.style.padding = "0 8px";
        cartForward.style.height = "40px";
        cartForward.style.alignItems = "center";
        cartForward.style.justifyContent = "center";
        cartForward.style.transition = "opacity 0.3s ease";

        // Fade in
        setTimeout(() => {
          cartForward.style.opacity = "1";
        }, 10);

        // Make it a link to /cart
        cartForward.onclick = (e) => {
          e.stopPropagation();
          window.location.href = "/cart";
        };
      }

      // Auto-reset after 1 second of success display
      successTimeoutId = setTimeout(() => {
        resetFromSuccess();
      }, 1000);
    }, 300);
  }

  // Function to apply image layout detection
  function applyImageLayout() {
    const additionalImages = document.querySelectorAll(
      ".additional-image-item img",
    );

    if (additionalImages.length === 0) return;

    // Check if we're on mobile (573px or below)
    const isMobile = window.innerWidth <= 573;
    const viewportWidth = window.innerWidth;

    // Remove any existing flex wrappers first to start fresh
    const existingWrappers = document.querySelectorAll(".additional-image-row");
    existingWrappers.forEach((wrapper) => {
      // Move children out of wrapper before removing it
      while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    });

    // Reset all containers to default state
    Array.from(additionalImages).forEach((img) => {
      const container = img.parentElement;
      container.style.width = "100dvw";
      container.style.height = "auto";
      container.style.aspectRatio = "";
      // hide until we determine layout to avoid visual jump
      if (img.style.visibility !== "hidden") {
        img.style.visibility = "hidden";
      }
    });

    // Preload the images via an off-DOM Image to get natural dimensions early.
    const aspectPromises = Array.from(additionalImages).map((img) => {
      return new Promise((resolve) => {
        const loader = new Image();
        loader.src = img.src;

        function finish() {
          const w = loader.naturalWidth || 1;
          const h = loader.naturalHeight || 1;
          const aspect = w / h;
          const isLandscape = aspect > 1;
          resolve({
            img,
            aspectRatio: aspect,
            isLandscape,
            naturalWidth: w,
            naturalHeight: h,
          });
        }

        if (loader.complete) {
          finish();
        } else {
          loader.onload = finish;
          loader.onerror = () => {
            resolve({ img, aspectRatio: 1, isLandscape: false });
          };
        }
      });
    });

    Promise.all(aspectPromises).then((imageAspectRatios) => {
      // If mobile, skip side-by-side logic - all images full width
      if (isMobile) {
        imageAspectRatios.forEach(
          ({ img, naturalWidth, naturalHeight, aspectRatio }) => {
            const container = img.parentElement;
            container.style.width = "100dvw";
            // Calculate height based on viewport width and aspect ratio
            const calculatedHeight = viewportWidth / aspectRatio;
            container.style.height = calculatedHeight + "px";
            img.style.visibility = "visible";
          },
        );
        return;
      }

      // Process images and apply layout for desktop
      let i = 0;
      while (i < imageAspectRatios.length) {
        const current = imageAspectRatios[i];
        const next = imageAspectRatios[i + 1];

        if (current.isLandscape) {
          // Landscape: full width - calculate height based on aspect ratio
          const container = current.img.parentElement;
          container.style.width = "100dvw";
          const calculatedHeight = viewportWidth / current.aspectRatio;
          container.style.height = calculatedHeight + "px";
          i++;
        } else {
          // Portrait: check if next is also portrait
          if (next && !next.isLandscape) {
            // Two portrait images side by side
            const halfWidth = viewportWidth / 2;

            // Use the taller of the two images to set consistent height
            const height1 = halfWidth / current.aspectRatio;
            const height2 = halfWidth / next.aspectRatio;
            const rowHeight = Math.max(height1, height2);

            current.img.parentElement.style.width = "50dvw";
            current.img.parentElement.style.height = rowHeight + "px";
            next.img.parentElement.style.width = "50dvw";
            next.img.parentElement.style.height = rowHeight + "px";

            // Create a flex wrapper
            const flexWrapper = document.createElement("div");
            flexWrapper.classList.add("additional-image-row");
            flexWrapper.style.display = "flex";
            flexWrapper.style.width = "100dvw";
            flexWrapper.style.height = rowHeight + "px";
            flexWrapper.style.gap = "0";

            // Insert wrapper before current image's parent
            const parent = current.img.parentElement.parentElement;
            parent.insertBefore(flexWrapper, current.img.parentElement);

            // Move both images into the wrapper
            flexWrapper.appendChild(current.img.parentElement);
            flexWrapper.appendChild(next.img.parentElement);

            i += 2;
          } else {
            // Single portrait or last portrait: full width
            const container = current.img.parentElement;
            container.style.width = "100dvw";
            const calculatedHeight = viewportWidth / current.aspectRatio;
            container.style.height = calculatedHeight + "px";
            i++;
          }
        }
      }

      // Make all images visible
      imageAspectRatios.forEach(({ img }) => {
        img.style.visibility = "visible";
      });
    });
  }

  // Run initial image layout on page load
  applyImageLayout();

  // Re-run layout on window resize to handle viewport changes
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      applyImageLayout();
    }, 150);
  });

  // Mobile cart control (product-4)
  const product4 = document.querySelector(".product-4");
  const product4Button = document.querySelector(".product-4-1");

  if (product4 && cartContainer && product4Button) {
    let hasBeenClicked = false;
    let isVisible = false;

    function isCartVisible() {
      const cartRect = cartContainer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Check if any part of the cart is visible in viewport
      return cartRect.top < viewportHeight && cartRect.bottom > 0;
    }

    // Determine if the user has scrolled past the cart (cart entirely above the viewport)
    function hasScrolledPastCart() {
      const cartRect = cartContainer.getBoundingClientRect();
      // true when the cart's bottom is above the viewport top
      return cartRect.bottom <= 0;
    }

    function showProduct4() {
      if (!isVisible && !hasBeenClicked) {
        isVisible = true;
        product4.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        product4.style.opacity = "1";
        product4.style.transform = "translateY(0)";
      }
    }

    function hideProduct4() {
      if (isVisible) {
        isVisible = false;
        product4.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        product4.style.opacity = "0";
        product4.style.transform = "translateY(10px)";
      }
    }

    function checkCartVisibility() {
      // If cart is visible, hide control
      if (isCartVisible()) {
        hideProduct4();
        return;
      }

      // If cart is not visible, only show the control after the user has scrolled past the cart
      // and not when they're at the very top of the page.
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrolledPast = hasScrolledPastCart();

      if (scrolledPast && scrollTop > 10 && !hasBeenClicked) {
        showProduct4();
      } else {
        hideProduct4();
      }
    }

    // Initial state: hidden with transform
    product4.style.opacity = "0";
    product4.style.transform = "translateY(10px)";

    // Check visibility on scroll
    let scrollTimeout;
    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        checkCartVisibility();
      }, 10);
    });

    // Check on resize
    window.addEventListener("resize", () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        checkCartVisibility();
      }, 100);
    });

    // Click handler: scroll to cart and fade out
    function handleProduct4Click() {
      // Scroll cart to center of viewport
      const cartRect = cartContainer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const cartHeight = cartRect.height;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      // Calculate position to center cart in viewport
      const targetScrollTop =
        scrollTop + cartRect.top - viewportHeight / 2 + cartHeight / 2;

      window.scrollTo({
        top: targetScrollTop,
        behavior: "smooth",
      });

      // Mark as clicked and fade out
      hasBeenClicked = true;
      product4.style.transition = "opacity 0.3s ease";
      product4.style.opacity = "0";
      isVisible = false;

      // Reset hasBeenClicked when cart goes off screen again
      const resetClickedState = () => {
        if (!isCartVisible()) {
          hasBeenClicked = false;
          checkCartVisibility();
        }
      };

      // Check periodically after click to detect when cart goes off screen
      const checkInterval = setInterval(() => {
        if (!isCartVisible() && hasBeenClicked) {
          hasBeenClicked = false;
          clearInterval(checkInterval);
        }
      }, 500);
    }

    // Make entire product-4 div clickable
    product4.addEventListener("click", handleProduct4Click);
    product4Button.addEventListener("click", handleProduct4Click);

    // Initial check
    checkCartVisibility();
  }

  // Dial selector rotation logic
  const dialKnob = document.querySelector(".svg-circle img, .svg-circle svg");
  const leftSelector = document.querySelector(".circle-selector-left");
  const topSelector = document.querySelector(".circle-selector-top");
  const rightSelector = document.querySelector(".circle-selector-right");

  if (dialKnob && leftSelector && topSelector && rightSelector) {
    // Track current position: 0 = left, 1 = top, 2 = right
    let currentPosition = 0;
    const positions = [leftSelector, topSelector, rightSelector];
    const rotations = [0, 90, 180]; // degrees for each position

    // Cache for preloaded product data
    const productDataCache = {};

    // Function to preload connected product data and images
    function preloadConnectedProducts() {
      positions.forEach(async (selector) => {
        const handle = selector.dataset.productHandle;
        if (handle && !productDataCache[handle]) {
          try {
            const response = await fetch(`/products/${handle}.js`);
            const data = await response.json();
            productDataCache[handle] = data;

            // Preload all product images with low priority
            if (data.images && data.images.length > 0) {
              data.images.forEach((imageUrl) => {
                const img = new Image();
                img.src = imageUrl;
              });
            }
          } catch (error) {
            // Silent fail for preload errors
          }
        }
      });
    }

    // Defer connected product preloading until after current product images are visible
    // This ensures the main product displays quickly first
    if ("requestIdleCallback" in window) {
      // Use idle callback to preload when browser is not busy
      requestIdleCallback(
        () => {
          preloadConnectedProducts();
        },
        { timeout: 2000 },
      ); // Start within 2 seconds max
    } else {
      // Fallback: delay preloading by 1 second
      setTimeout(preloadConnectedProducts, 1000);
    }

    // Set initial opacity states
    leftSelector.style.opacity = "1";
    topSelector.style.opacity = "0.5";
    rightSelector.style.opacity = "0.5";

    // Mark initial active selector
    leftSelector.classList.add("active");

    async function updateProductInfo(selector) {
      const productHandle = selector.dataset.productHandle;
      const productTitle = selector.dataset.productTitle;
      const productType = selector.dataset.productType;
      const productDescription = selector.dataset.productDescription;
      const productSku = selector.dataset.productSku;
      const productImage = selector.dataset.productImage;
      const productPrice = selector.dataset.productPrice;
      const variantId = selector.dataset.variantId; // Single variant ID (simplified)

      // Check current amplifier state
      const currentAmplifierSlider =
        document.getElementById("amplifier-slider");
      const isAmplifierActive =
        currentAmplifierSlider &&
        currentAmplifierSlider.classList.contains("slider-right");

      // Update title or clear if not available
      const titleElement = document.querySelector(
        ".product-header .type-header-desktop",
      );
      if (titleElement) {
        titleElement.textContent = productTitle || "";
      }

      // Update type or clear if not available
      const typeElements = document.querySelectorAll(".type-sku .type-micro");
      if (typeElements[0]) {
        typeElements[0].textContent = productType || "";
      }

      // Update SKU or clear if not available
      if (typeElements[1]) {
        let skuText = productSku || "";
        if (skuText && productTitle && productTitle.toLowerCase().includes("loudspeaker")) {
          if (skuText === skuText.toUpperCase()) {
            skuText += " (PAIR)";
          } else if (skuText === skuText.toLowerCase()) {
            skuText += " (pair)";
          } else {
            skuText += " (Pair)";
          }
        }
        typeElements[1].textContent = skuText;
      }

      // Update description - preserve <br> tags
      const descriptionContainer = document.querySelector(
        ".product-description",
      );
      if (descriptionContainer) {
        if (productDescription) {
          // Create a temporary div to parse the HTML
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = productDescription;

          // Replace <br> tags with newlines temporarily, get text, then convert back
          let htmlContent = tempDiv.innerHTML;
          // Convert <br> tags to placeholder
          htmlContent = htmlContent.replace(/<br\s*\/?>/gi, "|||BR|||");
          // Create new temp div with placeholders
          const textDiv = document.createElement("div");
          textDiv.innerHTML = htmlContent;
          // Get clean text
          let cleanText = textDiv.textContent || textDiv.innerText || "";
          // Convert placeholders back to single <br> tags
          cleanText = cleanText.replace(/\|\|\|BR\|\|\|/g, "<br>");

          // Clear existing content and set new content
          descriptionContainer.innerHTML = `<p>${cleanText}</p>`;
        } else {
          descriptionContainer.innerHTML = "<p></p>";
        }
      }

      // Update main product image or clear if not available
      const mainImage = document.querySelector(".product-main-image img");
      if (mainImage) {
        if (
          productImage &&
          productImage !== "undefined" &&
          productImage !== ""
        ) {
          mainImage.src = productImage;
          mainImage.alt = productTitle || "";
        } else {
          // If no image, you could set a placeholder or hide it
          mainImage.src = "";
          mainImage.alt = "";
        }
      }

      // Update price display - use amplifier price if active
      const priceDisplay = document.getElementById("product-price-display");
      if (priceDisplay) {
        // Start fading out the price immediately (will update after product data is fetched)
        priceDisplay.style.transition = "opacity 0.275s ease";
        priceDisplay.style.opacity = "0";
      }

      // Update amplifier slider with new product data (simplified - single variant per product)
      const amplifierSlider = document.getElementById("amplifier-slider");
      if (amplifierSlider) {
        // Update variant ID
        if (variantId && variantId !== "undefined") {
          amplifierSlider.dataset.variantId = variantId;
        }
        // Update product price
        if (productPrice && productPrice !== "undefined") {
          amplifierSlider.dataset.productPrice = productPrice;
        }
        // Update SKU
        if (productSku && productSku !== "undefined") {
          amplifierSlider.dataset.productSku = productSku;
        }
      }

      // Get metafield data from data attributes
      const dimensionsData = selector.dataset.dimensions;
      const specsMainData = selector.dataset.specsMain;
      const specsSubData = selector.dataset.specsSub;

      // Helper function to unescape HTML entities
      function unescapeHtml(text) {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = text;
        return textarea.value;
      }

      // Update dimensions from data attributes
      const dimensionsContainer = document.querySelector(".product-dimensions");
      if (dimensionsContainer) {
        if (
          dimensionsData &&
          dimensionsData !== "null" &&
          dimensionsData !== "undefined" &&
          dimensionsData !== ""
        ) {
          try {
            const unescapedData = unescapeHtml(dimensionsData);
            const dims = JSON.parse(unescapedData);
            // Now dims is directly the array, not wrapped in .value
            if (dims && Array.isArray(dims) && dims.length >= 3) {
              const w = Math.ceil(dims[0].value) + dims[0].unit;
              const h = Math.ceil(dims[1].value) + dims[1].unit;
              const d = Math.ceil(dims[2].value) + dims[2].unit;
              dimensionsContainer.innerHTML = `<p>${w} W x ${h} H x ${d} D</p>`;
            } else {
              dimensionsContainer.innerHTML = "";
            }
          } catch (e) {
            dimensionsContainer.innerHTML = "";
          }
        } else {
          dimensionsContainer.innerHTML = "";
        }
      }

      // Update main specifications from data attributes
      const specsMainContainer = document.querySelector(
        ".spec-container:first-child .spec-list",
      );
      if (specsMainContainer) {
        const dimensionsDiv = specsMainContainer.querySelector(
          ".product-dimensions",
        );
        if (
          specsMainData &&
          specsMainData !== "null" &&
          specsMainData !== "undefined" &&
          specsMainData !== ""
        ) {
          try {
            const unescapedData = unescapeHtml(specsMainData);
            const specs = JSON.parse(unescapedData);
            let specsHTML = "";
            // The data attribute now contains just the value array directly
            if (specs && Array.isArray(specs)) {
              specs.forEach((spec) => {
                specsHTML += `<p>${spec}</p>`;
              });
            }
            specsMainContainer.innerHTML = "";
            if (dimensionsDiv) {
              specsMainContainer.appendChild(dimensionsDiv);
            }
            specsMainContainer.insertAdjacentHTML("beforeend", specsHTML);
          } catch (e) {
            console.error("Error parsing specs main:", e, specsMainData);
            specsMainContainer.innerHTML = "";
            if (dimensionsDiv) {
              specsMainContainer.appendChild(dimensionsDiv);
            }
          }
        } else {
          specsMainContainer.innerHTML = "";
          if (dimensionsDiv) {
            specsMainContainer.appendChild(dimensionsDiv);
          }
        }
      }

      // Update sub specifications from data attributes
      const specsSubContainer = document.querySelector(
        ".spec-container:nth-child(2) .spec-list",
      );
      const specsSubParentContainer = document.querySelector(
        ".spec-container:nth-child(2)",
      );
      const container23 = document.querySelector(".container-2-3");

      let hasSpecsSub = false;

      if (specsSubContainer) {
        if (
          specsSubData &&
          specsSubData !== "null" &&
          specsSubData !== "undefined" &&
          specsSubData !== ""
        ) {
          try {
            const unescapedData = unescapeHtml(specsSubData);
            const specs = JSON.parse(unescapedData);
            let specsHTML = "";
            // The data attribute now contains just the value array directly
            if (specs && Array.isArray(specs) && specs.length > 0) {
              hasSpecsSub = true;
              specs.forEach((spec) => {
                specsHTML += `<p>${spec}</p>`;
              });
            }
            specsSubContainer.innerHTML = specsHTML;
          } catch (e) {
            console.error("Error parsing specs sub:", e, specsSubData);
            specsSubContainer.innerHTML = "";
          }
        } else {
          specsSubContainer.innerHTML = "";
        }
      }

      // Show/hide the entire Amplifier (Optional) container based on specs-sub data
      if (specsSubParentContainer) {
        specsSubParentContainer.style.display = hasSpecsSub ? "" : "none";
      }

      // Update container-2-3 class for layout adjustment
      if (container23) {
        if (hasSpecsSub) {
          container23.classList.remove("specs-sub-empty");
        } else {
          container23.classList.add("specs-sub-empty");
        }
      }

      // Fetch full product data to get additional images and update breadcrumb
      try {
        // Use cached data if available, otherwise fetch
        let productData;
        if (productDataCache[productHandle]) {
          productData = productDataCache[productHandle];
        } else {
          const response = await fetch(`/products/${productHandle}.js`);
          productData = await response.json();
          productDataCache[productHandle] = productData;
        }

        // Products now have single variant (no more Yes/No) - use first variant
        const productVariant = productData.variants[0];
        const productPriceFromFetch = productVariant.price;
        const isProductAvailable = productData.available;

        // Get UI elements for stock state handling
        const addToOrderDiv = document.querySelector(".add-to-order");
        const variantSelectorDiv = document.querySelector(
          ".product-variant-selector",
        );
        const notifyButton = document.querySelector(".notify-available");
        const cartOrderButton = document.querySelector(".cart-order");
        const productPriceDiv = document.querySelector(".product-price");
        const productSelectorDiv = document.querySelector(".product-selector");

        // Update out-of-stock data attribute and state variable
        if (addToOrderDiv) {
          if (isProductAvailable) {
            addToOrderDiv.removeAttribute("data-out-of-stock");
          } else {
            addToOrderDiv.setAttribute("data-out-of-stock", "true");
          }
        }

        // Update the main product out-of-stock state variable
        isMainProductOutOfStock = !isProductAvailable;

        // Reset email input mode state when switching products
        isEmailInputMode = false;

        // Handle stock state UI changes
        if (isProductAvailable) {
          // Product is in stock - show normal cart UI
          if (variantSelectorDiv) {
            variantSelectorDiv.style.display = "";
          }
          if (productSelectorDiv) {
            productSelectorDiv.style.display = "";
            productSelectorDiv.style.opacity = "1";
          }
          if (notifyButton) {
            notifyButton.style.display = "none";
          }
          if (cartOrderButton) {
            cartOrderButton.style.display = "block";
          }
          if (productPriceDiv) {
            productPriceDiv.style.display = "flex";
          }
          // Hide notification form elements when switching to in-stock product
          const notifyNameEl = document.querySelector(".notify-name-container");
          if (notifyNameEl) {
            notifyNameEl.style.display = "none";
          }
          const notifyEmailEl = document.querySelector(".notify-email-row");
          if (notifyEmailEl) {
            notifyEmailEl.style.display = "none";
          }
          // Clear notification inputs
          const notifyInputs = document.querySelectorAll(".notify-input");
          notifyInputs.forEach((input) => {
            input.value = "";
            input.classList.remove("has-value");
          });
          // Remove any thank you overlay
          const thankYouOverlay = document.querySelector(
            ".notify-thank-you-overlay",
          );
          if (thankYouOverlay) {
            thankYouOverlay.remove();
          }
          // Reset add-to-order styling
          if (addToOrderDiv) {
            addToOrderDiv.style.backgroundColor = "#ef9b00";
            addToOrderDiv.style.border = "";
          }
          // Show duties message when product is in stock
          const dutiesMessage = document.querySelector(
            ".product-cart-duties-message",
          );
          if (dutiesMessage) {
            dutiesMessage.style.display = "";
          }

          // Update amplifier price display for the new product
          const priceDiffDisplay = document.getElementById("amplifier-price");
          const amplifierPriceStored = parseInt(
            amplifierSlider?.dataset.amplifierProductPrice || "0",
          );
          const currency = amplifierSlider?.dataset.currency || "GBP";

          if (priceDiffDisplay) {
            if (isAmplifierActive && amplifierPriceStored > 0) {
              priceDiffDisplay.textContent =
                "+" +
                (amplifierPriceStored / 100)
                  .toFixed(2)
                  .replace(/\.00$/, "")
                  .replace(/(\.\d)0$/, "$1") +
                " " +
                currency;
            } else {
              priceDiffDisplay.textContent = "+0 " + currency;
            }
          }
        } else {
          // Product is out of stock - hide With Amplifier, show notify button, reset email state
          if (variantSelectorDiv) {
            variantSelectorDiv.style.display = "none";
          }
          // Restore product-selector visibility
          if (productSelectorDiv) {
            productSelectorDiv.style.display = "";
            productSelectorDiv.style.opacity = "1";
          }
          // Hide duties message when product is out of stock
          const dutiesMessageOOS = document.querySelector(
            ".product-cart-duties-message",
          );
          if (dutiesMessageOOS) {
            dutiesMessageOOS.style.display = "none";
          }
          // IMPORTANT: Hide cartForward IMMEDIATELY before showing notifyButton to prevent layout shift
          const cartForwardBtn = document.querySelector(".cart-page-forward");
          if (cartForwardBtn) {
            cartForwardBtn.style.display = "none";
            cartForwardBtn.style.opacity = "0";
          }
          if (notifyButton) {
            notifyButton.style.display = "block";
            notifyButton.style.opacity = "1"; // Reset opacity in case it was faded out
          }
          if (cartOrderButton) {
            cartOrderButton.style.display = "none";
          }
          // Hide notification form elements and reset state when switching to out-of-stock product
          const notifyNameEl = document.querySelector(".notify-name-container");
          if (notifyNameEl) {
            notifyNameEl.style.display = "none";
          }
          const notifyEmailEl = document.querySelector(".notify-email-row");
          if (notifyEmailEl) {
            notifyEmailEl.style.display = "none";
          }
          // Clear notification inputs
          const notifyInputs = document.querySelectorAll(".notify-input");
          notifyInputs.forEach((input) => {
            input.value = "";
            input.classList.remove("has-value");
          });
          // Remove any thank you overlay
          const thankYouOverlayOOS = document.querySelector(
            ".notify-thank-you-overlay",
          );
          if (thankYouOverlayOOS) {
            thankYouOverlayOOS.remove();
          }
          // Reset background color and justify-content in case it was changed
          if (addToOrderDiv) {
            addToOrderDiv.style.backgroundColor = "#ef9b00";
            addToOrderDiv.style.justifyContent = "center"; // Reset justify-content for centered notify text
            addToOrderDiv.style.border = ""; // Reset border
            // Remove any loading bars
            const loadingBar = addToOrderDiv.querySelector(".loading-bar");
            if (loadingBar) {
              loadingBar.remove();
            }
          }
          if (productPriceDiv) {
            productPriceDiv.style.display = "none";
          }
        }

        // Update amplifier slider with product price from fetch
        if (amplifierSlider) {
          amplifierSlider.dataset.productPrice = productPriceFromFetch;
          amplifierSlider.dataset.variantId = productVariant.id;

          // Get the stored amplifier price (from separate amplifier product)
          const amplifierPriceStored = parseInt(
            amplifierSlider.dataset.amplifierProductPrice || "0",
          );

          // Only update price display if product is available
          if (isProductAvailable) {
            // If amplifier is currently active, update the price display
            if (isAmplifierActive) {
              const priceDisplay = document.getElementById(
                "product-price-display",
              );
              const currency = amplifierSlider.dataset.currency || "GBP";

              // Update main price to show product + amplifier price with fade transition
              if (priceDisplay) {
                setTimeout(() => {
                  const totalPrice =
                    productPriceFromFetch + amplifierPriceStored;
                  const priceDollars = (totalPrice / 100)
                    .toFixed(2)
                    .replace(/\.00$/, "")
                    .replace(/(\.\d)0$/, "$1");
                  priceDisplay.textContent = priceDollars + " " + currency;
                  priceDisplay.style.opacity = "1";
                }, 275); // After fade out completes
              }
            } else {
              // Amplifier not active, show base price with fade transition
              const priceDisplay = document.getElementById(
                "product-price-display",
              );
              if (priceDisplay) {
                setTimeout(() => {
                  const priceDollars = (productPriceFromFetch / 100)
                    .toFixed(2)
                    .replace(/\.00$/, "")
                    .replace(/(\.\d)0$/, "$1");
                  const currency = amplifierSlider.dataset.currency || "GBP";
                  priceDisplay.textContent = priceDollars + " " + currency;
                  priceDisplay.style.opacity = "1";
                }, 275); // After fade out completes
              }
            }
          }
        }

        // Update breadcrumb
        const breadcrumbProduct = document.querySelector(".product-bread p");
        if (breadcrumbProduct) {
          breadcrumbProduct.textContent = productData.title;
        }

        // Update mobile purchase information price (product-4-2) - shows base price without amplifier
        const mobilePriceElement = document.querySelector(".product-4-2 p");
        if (mobilePriceElement) {
          const currency = amplifierSlider?.dataset.currency || "GBP";
          const basePriceDollars = (productPriceFromFetch / 100)
            .toFixed(2)
            .replace(/\.00$/, "")
            .replace(/(\.\d)0$/, "$1");
          mobilePriceElement.textContent = `Starting at ${basePriceDollars} ${currency}`;
        }

        // Update additional images in .product-3
        const additionalImagesContainer = document.querySelector(
          ".product-additional-images",
        );
        if (additionalImagesContainer && productData.images) {
          // Clear existing images
          additionalImagesContainer.innerHTML = "";

          // Add images starting from index 2 (skip first two images)
          productData.images.slice(2).forEach((imageUrl, index) => {
            const imageItem = document.createElement("div");
            imageItem.className = "additional-image-item";

            const img = document.createElement("img");
            img.src = imageUrl;
            img.alt = `${productData.title} additional image ${index + 3}`;
            img.style.visibility = "hidden"; // Hide until layout is calculated

            imageItem.appendChild(img);
            additionalImagesContainer.appendChild(imageItem);
          });

          // Run image layout detection on new images
          applyImageLayout();
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    }

    function updateActiveState(targetPosition) {
      // Remove active class from all
      positions.forEach((pos) => {
        pos.classList.remove("active");
      });
      // Add active class to target
      positions[targetPosition].classList.add("active");

      // Update product information
      updateProductInfo(positions[targetPosition]);

      // Update opacities
      positions.forEach((pos, idx) => {
        if (idx === targetPosition) {
          // New active selector fades in smoothly
          pos.style.opacity = "1";
        } else {
          // Elements going to 0.5 change instantly
          pos.style.transition = "none";
          pos.style.opacity = "0.5";
          void pos.offsetWidth; // Force reflow
          pos.style.transition = "";
        }
      });
    }

    // Clean hover handling similar to your reference
    function handleMouseEnter(event, index) {
      const hoveredSelector = event.target;
      const activeSelector = document.querySelector(
        ".circle-selector-left.active, .circle-selector-top.active, .circle-selector-right.active",
      );

      // Set hovered selector to full opacity (with transition)
      hoveredSelector.style.opacity = "1";

      // If hovering over a non-active selector, instantly dim the active one
      if (activeSelector && activeSelector !== hoveredSelector) {
        activeSelector.style.transition = "none";
        activeSelector.style.opacity = "0.5";
        // Re-enable transition after the instant change
        void activeSelector.offsetWidth; // Force reflow
        activeSelector.style.transition = "";
      }
    }

    function handleMouseLeave(event, index) {
      const hoveredSelector = event.target;
      const activeSelector = document.querySelector(
        ".circle-selector-left.active, .circle-selector-top.active, .circle-selector-right.active",
      );

      // Reset all to default state
      positions.forEach((pos) => {
        if (pos === activeSelector) {
          // Active selector fades in smoothly
          pos.style.opacity = "1";
        } else {
          // Non-active selectors instantly go to 0.5
          pos.style.transition = "none";
          pos.style.opacity = "0.5";
          void pos.offsetWidth; // Force reflow
          pos.style.transition = "";
        }
      });
    }

    function rotateTo(targetPosition) {
      if (targetPosition === currentPosition) return;

      // Calculate the actual current rotation angle
      const currentRotation = rotations[currentPosition];

      // Determine the rotation path
      const diff = targetPosition - currentPosition;
      let rotation;

      if (diff === 1) {
        // Clockwise: left->top, top->right
        rotation = currentRotation + 90;
      } else if (diff === -1) {
        // Counter-clockwise: right->top, top->left
        rotation = currentRotation - 90;
      } else if (diff === 2) {
        // left to right = +180 clockwise
        rotation = currentRotation + 180;
      } else if (diff === -2) {
        // right to left = -180 counter-clockwise
        rotation = currentRotation - 180;
      }

      // Apply rotation IMMEDIATELY for instant visual feedback
      dialKnob.style.transform = `rotate(${rotation}deg)`;

      // Update current position
      currentPosition = targetPosition;

      // Update active state (this will trigger product info update asynchronously)
      updateActiveState(currentPosition);
    }

    // Add hover and click event listeners to each selector
    positions.forEach((selector, index) => {
      selector.addEventListener("click", () => {
        // Reset to "Add to Order" if user interacts
        resetToAddToCart();
        rotateTo(index);
      });
      selector.addEventListener("mouseenter", (e) =>
        handleMouseEnter(e, index),
      );
      selector.addEventListener("mouseleave", (e) =>
        handleMouseLeave(e, index),
      );
    });

    // Click handler for the dial knob itself
    dialKnob.addEventListener("click", (e) => {
      e.stopPropagation(); // Prevent triggering selector clicks

      // Reset to "Add to Order" if user interacts
      resetToAddToCart();

      let nextPosition = currentPosition + 1;

      // If we're at the right (position 2), go back to left (position 0)
      if (currentPosition === 2) {
        // Calculate counter-clockwise rotation back to start
        const currentRotation = rotations[currentPosition];
        dialKnob.style.transform = `rotate(${currentRotation - 180}deg)`;
        currentPosition = 0;
        updateActiveState(currentPosition);
      } else {
        // Normal advancement: rotate 90deg clockwise
        rotateTo(nextPosition);
      }
    });
  }
});
